import type { DepositBonusCode } from '@repo-level/core-front';
import { AuthContext, setBonusCode, useApi } from '@repo-level/core-front';
import { REASON_FOR_UPDATING_USER } from '@repo-level/core-front/contexts/auth/reducer';
import { removeQueryParameterWithNavigation } from 'helpers/common';
import { groupMemberBR } from 'helpers/user';
import { useCallback, useContext, useEffect, useMemo } from 'react';
import { useCurrentRoute, useNavigation } from 'react-navi';

const BONUS_CODE_PARAM = 'bonus_code';

export function useBonusCode() {
  const { isAuthenticated, pendingUser, fetchUser, user, updateUser } =
    useContext(AuthContext);
  const isBonusRestricted = useMemo(() => groupMemberBR(user), [user]);
  const [requestsSetBonusCode] = useApi(setBonusCode);
  const navigation = useNavigation();
  const {
    url: { query },
  } = useCurrentRoute();

  const handleSetBonusCode = useCallback(
    async (values: DepositBonusCode) => {
      const { error } = await requestsSetBonusCode(values).request;

      if (!error) {
        updateUser(
          { depositBonusCode: values.depositBonusCode },
          REASON_FOR_UPDATING_USER.DEPOSIT
        );
      }
    },
    [requestsSetBonusCode, updateUser]
  );

  useEffect(() => {
    if (!query[BONUS_CODE_PARAM] || pendingUser || !isAuthenticated) return;

    !isBonusRestricted &&
      handleSetBonusCode({ depositBonusCode: query[BONUS_CODE_PARAM] });
    removeQueryParameterWithNavigation(navigation, query, BONUS_CODE_PARAM);
  }, [
    isAuthenticated,
    pendingUser,
    query,
    navigation,
    handleSetBonusCode,
    isBonusRestricted,
  ]);
}
